module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAANCAYAAABPeYUaAAAAkElEQVQ4T9XRPQ4BQRgG4Gcbx1C5ibgHrRNIVKKWbO0car0DOIJaQyjEyIhJNhtrh61MPe/z/RUhhJtu71iEEO4oOjhPZIw5Bj9AeywiUmKF4RdYDC+xwzSNc8U6A6uGZ5jgXN/JpQF7F+69xm9cbBXr44BUOYXTCluvE7EtRqiHs5Gcg7V28ofIJqfnD39OD3Q3VLeaC4hbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/email.png
// module id = VJ+y
// module chunks = 0